var React = require('react');

function CompareTick (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_35_2581)","key":0},[React.createElement("path",{"d":"M45.3334 17.3335C45.3334 32.7975 32.7973 45.3335 17.3334 45.3335C1.8694 45.3335 -10.6666 32.7975 -10.6666 17.3335C-10.6666 1.86952 1.8694 -10.6665 17.3334 -10.6665C32.7973 -10.6665 45.3334 1.86952 45.3334 17.3335Z","fill":"#6FCF97","key":0}),React.createElement("path",{"d":"M13 20.1701L8.83003 16.0001L7.41003 17.4101L13 23.0001L25 11.0001L23.59 9.59009L13 20.1701Z","fill":"white","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_35_2581"},React.createElement("path",{"d":"M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z","fill":"white"})))]);
}

CompareTick.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CompareTick;

CompareTick.default = CompareTick;
